module.exports = __webpack_public_path__ + "static/media/empower.a58e6ace.png";